import React, { useState } from 'react';
import { Video, Calendar, Clock, CheckCircle } from 'lucide-react';
import api from '../api/axios';
import { toast } from 'sonner';

const VideoKYC = ({ onSuccess }) => {
  const [formData, setFormData] = useState({
    preferred_date: '',
    preferred_time: '',
    purpose: 'loan_verification',
    notes: ''
  });
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await api.post('/kyc/schedule', formData);
      toast.success('Video KYC scheduled successfully! You will receive a confirmation via SMS/WhatsApp.');
      setFormData({
        preferred_date: '',
        preferred_time: '',
        purpose: 'loan_verification',
        notes: ''
      });
      if (onSuccess) onSuccess();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Failed to schedule KYC');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-white p-6 rounded-xl border border-gray-200 shadow-sm">
      <div className="flex items-center gap-3 mb-6">
        <Video className="text-[#354F37]" size={28} />
        <div>
          <h3 className="text-xl font-bold text-[#222222]">Schedule Video KYC</h3>
          <p className="text-sm text-[#444444]">Fast-track your verification process</p>
        </div>
      </div>

      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block text-[#222222] mb-2 font-semibold">
            <Calendar className="inline mr-2" size={16} />
            Preferred Date
          </label>
          <input
            type="date"
            required
            min={new Date().toISOString().split('T')[0]}
            value={formData.preferred_date}
            onChange={(e) => setFormData({...formData, preferred_date: e.target.value})}
            className="w-full px-4 py-3 rounded-lg bg-white border border-gray-300 text-[#444444] focus:outline-none focus:ring-2 focus:ring-[#354F37]"
          />
        </div>

        <div>
          <label className="block text-[#222222] mb-2 font-semibold">
            <Clock className="inline mr-2" size={16} />
            Preferred Time
          </label>
          <select
            required
            value={formData.preferred_time}
            onChange={(e) => setFormData({...formData, preferred_time: e.target.value})}
            className="w-full px-4 py-3 rounded-lg bg-white border border-gray-300 text-[#444444] focus:outline-none focus:ring-2 focus:ring-[#354F37]"
          >
            <option value="">Select time slot</option>
            <option value="10:00 AM">10:00 AM</option>
            <option value="11:00 AM">11:00 AM</option>
            <option value="12:00 PM">12:00 PM</option>
            <option value="02:00 PM">02:00 PM</option>
            <option value="03:00 PM">03:00 PM</option>
            <option value="04:00 PM">04:00 PM</option>
            <option value="05:00 PM">05:00 PM</option>
          </select>
        </div>

        <div>
          <label className="block text-[#222222] mb-2 font-semibold">Additional Notes (Optional)</label>
          <textarea
            value={formData.notes}
            onChange={(e) => setFormData({...formData, notes: e.target.value})}
            rows="3"
            className="w-full px-4 py-3 rounded-lg bg-white border border-gray-300 text-[#444444] placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[#354F37]"
            placeholder="Any specific requirements or questions..."
          ></textarea>
        </div>

        <button
          type="submit"
          disabled={loading}
          className="w-full bg-[#354F37] text-white px-6 py-3 rounded-lg font-semibold hover:bg-[#426045] transition disabled:opacity-50 flex items-center justify-center gap-2"
        >
          {loading ? 'Scheduling...' : (
            <>
              <CheckCircle size={20} />
              Schedule Video KYC
            </>
          )}
        </button>
      </form>

      <div className="mt-4 p-4 bg-[#F8F4EF] rounded-lg">
        <p className="text-sm text-[#444444]">
          <strong>Note:</strong> Please keep the following documents ready:
        </p>
        <ul className="text-sm text-[#444444] mt-2 space-y-1">
          <li>• PAN Card</li>
          <li>• Aadhaar Card</li>
          <li>• Recent photograph</li>
        </ul>
      </div>
    </div>
  );
};

export default VideoKYC;
